import React, { ReactNode } from 'react';
import styled from '@xstyled/styled-components';
import OpenPopupAudio from '~/assets/mp3/open_nav.mp3';
import WrongAnswerAudio from '~/assets/mp3/wrong_answer.mp3';
import RightAnswerAudio from '~/assets/mp3/right_answer.mp3';
import { useQuizOrderStore } from '../QuizOrderStore';
import { useAudioEffect } from '~/ui/audio-effect/useAudioEffect';

const StyledCheckButton = styled.buttonBox`
  position: absolute;
  display: flex;
  align-items: center;
  gap: 15px;
  bottom: 20px;
  right: 20px;
  background-color: ${p => p.theme.colors.accentDark};
  color: #ffffff;
  padding: 0px 28px;
  border-radius: 20px;
  height: 40px;
`;

export const CheckButton = ({
  children,
  setIsOpened
}: {
  children: ReactNode;
  setIsOpened: (state: boolean) => void;
}) => {
  const { popupWasOpened, handleCheckAnswers } = useQuizOrderStore();
  const [OpenPopupAudioEffect] = useAudioEffect(OpenPopupAudio);
  const [playWrongAnswerAudioEffect] = useAudioEffect(WrongAnswerAudio);
  const [playRightAnswerAudioEffect] = useAudioEffect(RightAnswerAudio);

  const handleClickCheckButton = () => {
    if (popupWasOpened) {
      handleCheckAnswers(
        playWrongAnswerAudioEffect,
        playRightAnswerAudioEffect
      );
      return;
    }

    OpenPopupAudioEffect();
    setIsOpened(true);
  };

  return (
    <StyledCheckButton onClick={handleClickCheckButton}>
      {children}
    </StyledCheckButton>
  );
};
